var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_BlockLeavePolicy_form_property_dialog_title"),
      dialog: _vm.show,
      maxWidth: "400",
    },
    on: {
      close: function ($event) {
        _vm.show = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "white lighten-5",
                    attrs: { align: "center", justify: "start" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          staticClass: "flex-grow-1",
                          attrs: {
                            isRequired: "",
                            "two-line": "",
                            items: _vm.LeaveTypeList,
                            "item-text": "leave_type_name",
                            label: "label_essweb_leaveType_list_title",
                            "item-value": "uuid",
                            rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "selection",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.leave_type_name
                                        )
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text--secondary text-caption",
                                    },
                                    [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              data.item.leave_type_abbr
                                            )
                                          ) +
                                          ")"
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.title",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.leave_type_name
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "item.subtitle",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          data.item.leave_type_abbr
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.leave_type_uuid,
                            callback: function ($$v) {
                              _vm.leave_type_uuid = $$v
                            },
                            expression: "leave_type_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: {
                save: _vm.toSave,
                cancel: function ($event) {
                  _vm.show = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }